import InfoIcon from '@mui/icons-material/Info'
import { FormControl, FormHelperText, MenuItem, Select, Tooltip } from '@mui/material'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import { withAsteriskIfRequired } from 'src/utils/string'

const SelectDropdown = ({
  helperText,
  name,
  helperTextStyle,
  value,
  handleChange,
  handleOnBlur,
  options,
  adaptWidth,
  renderTooltip,
  toolTipText,
  isDisabled,
  required = false,
}) => {
  const renderTooltipIcon = () => {
    if (!renderTooltip) return null

    return (
      <Tooltip placement="top" title={toolTipText}>
        <InfoIcon sx={{ marginLeft: 0.5, fontSize: '.875rem' }} />
      </Tooltip>
    )
  }

  const renderOptions = () =>
    options.length
      ? options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))
      : null

  const curatedHelperText = withAsteriskIfRequired(helperText, required)

  return (
    <>
      <FormHelperText id="outlined-weight-helper-text" className={helperTextStyle}>
        {curatedHelperText}
        {renderTooltipIcon()}
      </FormHelperText>
      <FormControl fullWidth size="small">
        <Select
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleOnBlur}
          autoWidth={adaptWidth}
          disabled={isDisabled}
          required={required}
        >
          {renderOptions()}
        </Select>
      </FormControl>
    </>
  )
}

SelectDropdown.defaultProps = {
  helperText: '',
  name: '',
  helperTextStyle: '',
  handleChange: noop,
  handleOnBlur: noop,
  value: '',
  options: [],
  adaptWidth: false,
  renderTooltip: false,
  toolTipText: '',
  isDisabled: false,
  required: false,
}

SelectDropdown.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string,
  helperTextStyle: PropTypes.string,
  handleChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  value: PropTypes.string,
  options: PropTypes.array,
  adaptWidth: PropTypes.bool,
  renderTooltip: PropTypes.bool,
  toolTipText: PropTypes.string,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,
}

export default SelectDropdown
